import * as React from "react";
import { useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import usePluginEntities from "hooks/usePluginEntities";
import mergeNavigationItems from "components/navigation/util/mergeNavigationItems";
import AppConfig from "util/AppConfig";
import { DEFAULT_PERSPECTIVE } from "components/perspectives/contexts/PerspectivesProvider";
import useActivePerspective from "components/perspectives/hooks/useActivePerspective";
import NavTabs from "components/common/NavTabs";
const matchesPerspective = (activePerspective, itemPerspective) => activePerspective === DEFAULT_PERSPECTIVE ? !itemPerspective : itemPerspective === activePerspective;
const usePageNavigationItems = (page, items) => {
  const { activePerspective } = useActivePerspective();
  const allPageNavigationItems = usePluginEntities("pageNavigation");
  return useMemo(() => {
    var _a, _b;
    if (items) {
      return items;
    }
    const perspectiveNavItems = allPageNavigationItems.filter(
      (group) => matchesPerspective(activePerspective.id, group.perspective)
    );
    return (_b = (_a = mergeNavigationItems(perspectiveNavItems).find((item) => item.description === page)) == null ? void 0 : _a.children) != null ? _b : [];
  }, [items, allPageNavigationItems, activePerspective.id, page]);
};
const PageNavigation = ({ page = void 0, items: itemsProp = void 0 }) => {
  const currentUser = useCurrentUser();
  const items = usePageNavigationItems(page, itemsProp);
  const availableItems = items.filter(
    (item) => (item.requiredFeatureFlag ? AppConfig.isFeatureEnabled(item.requiredFeatureFlag) : true) && (typeof item.useCondition === "function" ? item.useCondition() : true) && isPermitted(currentUser.permissions, item.permissions) && !!item.path
  );
  const formatedItems = sortNavigationItems(availableItems);
  if (formatedItems.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(NavTabs, { items: formatedItems });
};
export default PageNavigation;
